module.exports = __webpack_public_path__ + "80407d1c8d6af419a3611c1b5ff22e60.png";